import { Button } from "../atoms/button.js";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "../atoms/card.js";
import { LinkButton } from "../atoms/link-button.js";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
//#region src/components/organisms/feature-gallery.tsx
const FeatureGallery = ({ items }) => {
	return /* @__PURE__ */ jsx("div", {
		className: "@container w-full",
		children: /* @__PURE__ */ jsx("div", {
			className: "@md:grid-cols-2 @lg:grid-cols-3 gap-8 grid grid-cols-1",
			children: items.map(({ title, icon, description, actions }) => /* @__PURE__ */ jsxs(Card, {
				className: "elevation-3 py-8 gap-4 transition-shadow",
				children: [
					/* @__PURE__ */ jsxs(CardHeader, {
						className: "gap-4 px-8 flex flex-col items-center text-center",
						children: [/* @__PURE__ */ jsx("div", {
							className: "p-4 bg-accent rounded-full",
							children: icon
						}), /* @__PURE__ */ jsx(CardTitle, {
							className: "text-lg leading-tight",
							children: title
						})]
					}),
					/* @__PURE__ */ jsx(CardContent, {
						className: "gap-4 px-8 flex flex-col items-center",
						children: /* @__PURE__ */ jsx("p", {
							className: "leading-relaxed text-muted-foreground text-center",
							children: description
						})
					}),
					/* @__PURE__ */ jsx(CardFooter, {
						className: "px-8 pt-4",
						children: /* @__PURE__ */ jsx("div", {
							className: "gap-3 flex w-full flex-col",
							children: actions?.map(({ label, icons, ...action }) => {
								const content = /* @__PURE__ */ jsxs(Fragment, { children: [
									icons?.left && /* @__PURE__ */ jsx(icons.left, {}),
									/* @__PURE__ */ jsx("span", { children: label }),
									icons?.right && /* @__PURE__ */ jsx(icons.right, {})
								] });
								if ("href" in action) return /* @__PURE__ */ jsx(LinkButton, {
									href: action.href,
									children: content
								}, label);
								else return /* @__PURE__ */ jsx(Button, {
									onClick: action.callback,
									children: content
								}, label);
							})
						})
					})
				]
			}, title + description))
		})
	});
};
//#endregion
export { FeatureGallery };

//# sourceMappingURL=feature-gallery.js.map